// @ts-nocheck
import ProductDescription from 'components/modules/e-commerce/ProductDescription';
import ProductDetailsTab from 'components/modules/e-commerce/ProductDetailsTab';
import { topElectronicProducts } from 'data/e-commerce/products';
import SimilarProducts from 'components/sliders/SimilarProducts';
import Section from 'components/base/Section';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { ecomBreadcrumbItems } from 'data/commonData';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { getCookie, isAuth } from 'helpers/helpers';

const ProductDetails = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [ean, setEan] = useState();
  const [product, setProduct] = useState({});
  const [similarProducts, setSimilarProducts] = useState([]);

  useEffect(() => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');
      const productEAN = searchParams.get('ean');

      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/receive-one-product',
        data: { ean: productEAN },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          setProduct(response.data.oneProduct);
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  }, [searchParams]);

  const getOtherVariant = (bildnummer, variantennummer) => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');

      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/receive-other-variant',
        data: { bildnummer, variantennummer },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          setProduct(response.data.oneProduct);
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  };

  useEffect(() => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');
      const productCategory = searchParams.get('category');
      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/similar-products',
        data: { categoryFilter: productCategory },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          const similarProductsArray = response.data.similarProducts;
          const similarProductsFinal = [];
          similarProductsArray.forEach(item => {
            similarProductsFinal.push({
              id: item && item.id && item.id,
              image:
                item &&
                item.ean_gtins &&
                item.ean_gtins[0] &&
                item.ean_gtins[0].Bild_URL &&
                item.ean_gtins[0].Bild_URL,
              name: item && item.Titel_Deutsch && item.Titel_Deutsch,
              url:
                item &&
                item.EAN &&
                `/primedeco/product-details?ean=${item.EAN}&category=${item.Hauptkategorie}`,
              Anzahl_Varianten: item.Anzahl_Varianten && item.Anzahl_Varianten,
              Variantennummer: item.Variantennummer && item.Variantennummer,
              extraClass: 'text-body-highlight fs--1 mb-0 fw-bold',
              extra2: item && item.Hauptkategorie && item.Hauptkategorie,
              extra2Class: 'text-body-tertiary fs--1 mb-2'
            });
          });
          setSimilarProducts(similarProductsFinal);
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  }, [searchParams]);

  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        <PageBreadcrumb items={ecomBreadcrumbItems} className="mb-3" />
        <ProductDescription
          product={product}
          getOtherVariant={getOtherVariant}
        />
      </Section>

      <Section small className="py-0">
        <div className="mb-9">
          <ProductDetailsTab product={product} />
        </div>
      </Section>

      <Section className="py-0">
        <SimilarProducts products={similarProducts} />
      </Section>
    </div>
  );
};

export default ProductDetails;
